import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <path
      d="M6,2 L1,2 L1,13 L15,13 L15,3.5 L7.125,3.5 C6.50367966,3.5 6,2.99632034 6,2.375 L6,2 Z M6.25,1 C6.66421356,1 7,1.33578644 7,1.75 L7,2.375 C7,2.44403559 7.05596441,2.5 7.125,2.5 L15,2.5 C15.5522847,2.5 16,2.94771525 16,3.5 L16,13 C16,13.5522847 15.5522847,14 15,14 L1,14 C0.44771525,14 -2.12486467e-14,13.5522847 -2.13162821e-14,13 L-2.55351296e-14,2 C-2.56027649e-14,1.44771525 0.44771525,1 1,1 L6.25,1 Z"/>
  </svg>
);
